import React from 'react';

import SelectView from './Views/SelectView';
import CheckboxView from './Views/CheckboxView';
import TextView from './Views/TextView';
import TimelineView from './Views/TimelineView';
import TimelineSingleChoiceView from './Views/TimelineSingleChoiceView';

const ViewsByType = {
  select: SelectView,
  'stats_header': CheckboxView,
  text: TextView,
  timeline: TimelineView,
  'timeline-single-choice': TimelineSingleChoiceView
};

class StatisticsQuestionView extends React.Component {
  addNotReportedToData(data) {
    const numberStates = this.props.numberStates;

    const reportedTotal = data.reduce(function(acc, val) {
      return acc + val.value;
    }, 0);

    const notReportedTotal = numberStates - reportedTotal;

    if (notReportedTotal > 0) {
      data.push({
        name: 'No data*',
        value: notReportedTotal
      });
    }

    return data;
  }

  formatData(data) {
    if (Array.isArray(data)) return data;

    const formattedData = Object.keys(data).map(key => {
      return {
        name: key,
        value: data[key]
      };
    });
    return this.addNotReportedToData(formattedData);
  }

  renderDefault(type) {
    return (
      <div>
        Dataviz for type <strong>{type}</strong> not yet implemented
      </div>
    );
  }

  render() {
    const { type, results, numberStates, participation } = this.props,
      ViewComponent = ViewsByType[type];

    if (!ViewComponent) return this.renderDefault(type);

    return (
      <ViewComponent
        data={ this.formatData(results) }
        numberStates={ numberStates }
        participation={ participation }
      />
    );
  }
}

export default StatisticsQuestionView;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsQuestionView.js